module.exports = __webpack_public_path__ + "dc5311d6e52975678ef3c580b61f3adf.png";